import React, { Component, useState } from "react";
import { withRouter, Link } from 'react-router-dom';
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

function Header(props) {

  const [isShareActive, setIsShareActive] = useState(false);
  const { location, history } = props;
  let headerClassName;

  if (window.location.href.includes('article'))
    headerClassName = "article"

  const activateSharer = (e) => {
    setIsShareActive(!isShareActive);
  }

  return (
    <header className={headerClassName}>
      <div id="header" /*className={`${(this.state.isSlided ? "active" : "")}`}*/ >
        <div className="padding">
          <div className="container">
            <div className="publisher">
              <a href="https://www.ynet.co.il/" target="_blank"><div className="logo"></div></a>
              <div className="img-logo header-icon2" onClick={_ => history.push('/')} />
              <div onClick={_ => history.push('/')} className="img-logo header-icon3" />
            </div>
            <div className="utils">
              <div className={`share${(isShareActive ? " active " : "")}`}>
                <Link to="/" className="img-logo goback-desktop" />
                <div onClick={shareWhatsapp} className="desktop-share whatsapp" />
                <div onClick={shareFacebook} className="desktop-share facebook" />
                <div onClick={activateSharer} className="sharer"></div>
                <div onClick={openNegishut} className="negishut"></div>
                <Link to="/" className="img-logo goback-mobile" />
                <ul className={`sharers-container ${isShareActive ? "active" : ""}`}>
                  <li onClick={shareWhatsapp} className="whatsapp" />
                  <li onClick={shareFacebook} className="facebook" />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="virtualHeader"></div>
    </header>
  );
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx